import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { AppValueTypes } from '@iotv/iotv-v3-types';
import { FormControl, FormControlLabel, Switch } from '@mui/material';
import React from 'react';
import { ComponentMode } from '../../../types/AppTypes';
export const BooleanComponent = (props) => {
    const { matchedPrimary, viewKeyDefinition: { key, label, editable, type }, mode, updateKV, } = props;
    const classes = {};
    let element = null;
    if (type === AppValueTypes.BOOLEAN) {
        const value = matchedPrimary[key] ? matchedPrimary[key] : false;
        if (editable !== true || mode === ComponentMode.VIEW || mode === ComponentMode.READONLY) {
            return (_jsxs("div", { children: [mode === ComponentMode.VIEW || mode === ComponentMode.READONLY ? '' : `${label}: `, matchedPrimary[key] !== undefined ? (matchedPrimary[key] === true ? '\u2713' : '\u2716') : '?'] }));
        }
        else if (mode === ComponentMode.EDIT) {
            element = (_jsx(FormControl, { className: classes.editFormControlFullWidth, size: 'small', children: _jsx(FormControlLabel, { label: label, control: _jsx(Switch, { checked: value, onChange: (event) => updateKV(event, key), name: label, inputProps: { 'aria-label': 'secondary checkbox' }, size: 'small' }) }) }));
        }
    }
    return element;
};
